<template>
		<span class="spinner">
				<div class="bounce1" :style="'background-color:'+color"></div>
				<div class="bounce2" :style="'background-color:'+color"></div>
				<div class="bounce3" :style="'background-color:'+color"></div>
		</span>
</template>

<script>
	// Many thanks to https://tabler-icons.io/static/tabler-icons/icons/qrcode.svg
	export default {
		name: 'LoadingDots',
		props: {
      // This is passed by the parent so we can pass it back up when emitting
      color: {
          type: String,
          default: '#544098',
      },
    },
	}
</script>

<style scoped>
		/*Huge thanks to @tobiasahlin at http://tobiasahlin.com/spinkit/ */
		.spinner {
				margin: 0 auto 0;
				width: 70px;
				text-align: center;
		}

		.spinner > div {
				width: 18px;
				height: 18px;
				border-radius: 100%;
				display: inline-block;
				-webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
				animation: sk-bouncedelay 1.4s infinite ease-in-out both;
		}

		.spinner .bounce1 {
				-webkit-animation-delay: -0.32s;
				animation-delay: -0.32s;
		}

		.spinner .bounce2 {
				-webkit-animation-delay: -0.16s;
				animation-delay: -0.16s;
		}

		@-webkit-keyframes sk-bouncedelay {
				0%, 80%, 100% { -webkit-transform: scale(0) }
				40% { -webkit-transform: scale(1.0) }
		}

		@keyframes sk-bouncedelay {
				0%, 80%, 100% {
						-webkit-transform: scale(0);
						transform: scale(0);
				} 40% {
							-webkit-transform: scale(1.0);
							transform: scale(1.0);
					}
		}
</style>